<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-model="formData.phone"
            :rules="rules.phone"
            :label="$t('inputs.phone.name')"
            v-mask="'(###) ###-##-##'"
            prefix="+7 "
            :error-messages="errorMessages.phone"
            ref="phoneNumber"
            :disabled="hasCode"
            required
            @paste="checkPastePhone"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="hasCode">
        <v-flex shrink mt-0 pt-0>
          <v-text-field
            v-model="confirmData.phone_confirm_code"
            :label="$t('inputs.confirmCode.name')"
            v-mask="'######'"
            class="register__phone"
            ref="phoneCode"
            @keyup.enter="confirmPhone"
          ></v-text-field>
        </v-flex>
        <v-flex shrink justify-end mt-0 pt-0>
          <v-btn color="primary" @click="confirmPhone" class="mt-0"
            >{{$t('inputs.confirmCode.extra.confirmBtn')}}</v-btn
          >
        </v-flex>
      </v-layout>

      <div v-if="errors" class="mb-5">
        <strong>{{ errors }}</strong>
      </div>

      <p class="mt-0" v-if="hasCode">
        {{$t('inputs.confirmCode.extra.noGetCode')}}
        <span v-if="isCodeTimeout"
          >{{$t('inputs.confirmCode.extra.codeLimitText', {codeTimeout: codeTimeout})}}</span
        >
        <span v-else @click="getPhoneCode">
          <strong>{{$t('inputs.confirmCode.extra.sendNewText')}}</strong>
        </span>
      </p>

      <v-btn
        v-if="!hasCode"
        color="primary"
        @click="getPhoneCode"
        :disabled="!formData.phone || formData.phone.length < 10"
        >{{$t('inputs.confirmCode.extra.getCodeBtn')}}</v-btn
      >
    </v-flex>
  </v-layout>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import rules from "@/utils/data/rules";
import roles from "@/utils/data/roles";
import { mask } from "vue-the-mask";

export default {
  name: "RegisterPhone",
  directives: { mask },
  data: () => ({
    hasCode: false,
    // phoneCode: "",
    // phoneHash: "",
    codeTimeout: 0,
    isCodeTimeout: true,
    errors: null,
    errorMessages: {
      full_name: "",
      email: "",
      phone: "",
    },
    rules,
    roles,
  }),
  props: {
    formData: {
      type: Object,
    },
    confirmData: {
      type: Object,
    },
  },
  methods: {
    checkPastePhone(e) {
      let clipboardData = e.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData("Text");
      let phoneData = this.getPhoneNumber("7", pastedData);
      if (phoneData.length == 11) {
        phoneData =
          "(" +
          phoneData.substr(1, 3) +
          ") " +
          phoneData.substr(4, 3) +
          "-" +
          phoneData.substr(7, 2) +
          "-" +
          phoneData.substr(9, 2);
        this.formData.phone = phoneData;
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    },

    getPhoneNumber(append = "7", otherNumber = null) {
      let result = otherNumber;
      if (!result) result = "";

      result = result.replace(/[+()\s-]/g, "");
      result = result.substr(-10);
      if (result) result = append + result;
      return result;
    },

    getPhoneCode() {
      this.errors = null;
      try {
        window.dataLayer.push({
          event: "trackEvent",
          eventCategory: "RegisterForm",
          eventAction: "Tel",
          eventLabel: this.formData.phone,
        });
      } catch (e) {
        console.warn(e);
      }
      apiCallTrue({
        url: "v1/users/register-send-sms",
        method: "POST",
        data: {
          phone: this.formData.phone,
        },
      })
        .then((response) => {
          try {
            window.dataLayer.push({
              event: "trackEvent",
              eventCategory: "RegisterForm",
              eventAction: "OTP code",
            });
          } catch (e) {
            console.warn(e);
          }
          // this.phoneHash = response.data.data.hash;
          this.$emit(
            "updateForm",
            "confirmDataPhone",
            response.data.data.hash,
            response.data.data.phone,
            response.data.data.phoneHash,
            response.data.data.result_id
          );

          this.phoneCode = "";

          this.hasCode = true;
          this.codeTimeout = 120;
          this.isCodeTimeout = true;
          setTimeout(() => this.$refs.phoneCode.focus(), 100);
          this.getCodeTimeout();
        })
        .catch((error) => {
          this.errors = error.message;
        });
    },
    confirmPhone() {
      const data = {
        phone_confirm_code: this.confirmData.phone_confirm_code,
        hash: this.confirmData.hash,
        phone: this.formData.phone,
        result_id: this.confirmData.result_id,
      };

      try {
        window.dataLayer.push({
          event: "trackEvent",
          eventCategory: "RegisterForm",
          eventAction: "OTP",
        });
      } catch (e) {
        console.warn(e);
      }

      apiCallTrue({
        url: "v1/users/phone-confirmation",
        method: "POST",
        data,
      })
        .then((response) => {
          if (response.data.result) {
            this.phoneConfirmed = response.data.result;
            // this.$refs.form.reset();
            // this.errors = null;
            try {
              window.dataLayer.push({
                event: "trackEvent",
                eventCategory: "RegisterForm",
                eventAction: "Confirm",
              });
            } catch (e) {
              console.warn(e);
            }

            this.$emit("updateForm", "phoneConfirmed", response.data.result);
          } else {
            this.errors = response.data.message;
          }
        })
        .catch((error) => {
          this.errors = error.message;
        });
    },
    getCodeTimeout() {
      if (this.codeTimeout <= 0) return false;
      const codeInterval = setInterval(() => {
        this.codeTimeout--;
      }, 1000);

      setTimeout(() => {
        clearInterval(codeInterval);
        this.isCodeTimeout = false;
      }, 60000);
      return true;
    },
  },
  mounted() {
    this.$refs.phoneNumber.focus();
  },
};
</script>
